export default class ZenDeskTicketCommentModel {
  public id!: number;
  public commentText!: string;
  public authorId!: number;
  public authorName!: string;
  public isPublic!: boolean;
  public createdAt!: Date;
}
